module.exports = __webpack_public_path__ + "pc-top-assets/img/facebook.8ba4ae55.svg";